export const DEFAULT_GROUP_ID = 'default';

export const textDictionary = {
  recommendedProducts: 'Productos Recomendados',
  recommendedKnowMore: 'Conocer más',
  viewProduct: 'Ver producto',
};

export const EMPTY_GROUP_IMG = {
  alt: 'No products found',
  src: 'https://images.falabella.com/v3/assets/blt6a203fe6c6a9b6dd/blt471cc4cde836cc00/empty-group-result.svg',
};
